import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "dialog-allocate-info" };
const _hoisted_2 = ["onClick", "onMouseover", "onMouseleave"];
const _hoisted_3 = { class: "head" };
const _hoisted_4 = { class: "title-text" };
const _hoisted_5 = ["innerHTML"];
const _hoisted_6 = {
    key: 1,
    class: "store"
};
const _hoisted_7 = {
    key: 2,
    class: "order"
};
const _hoisted_8 = {
    key: 3,
    class: "worker"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_icon = _resolveComponent("v-icon");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, key) => {
            return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: _normalizeClass(["item body2-text", _ctx.itemClass(key)]),
                onClick: ($event) => (_ctx.handleClickItem(key)),
                onMouseover: ($event) => (_ctx.handleMouseoverItem(key)),
                onMouseleave: ($event) => (_ctx.handleMouseleaveItem(key))
            }, [
                _createVNode(_component_v_icon, {
                    class: "close-btn",
                    size: "16",
                    color: "black",
                    onClick: _withModifiers(($event) => (_ctx.handleClickCloseBtn(key)), ["stop"])
                }, {
                    default: _withCtx(() => _cache[0] || (_cache[0] = [
                        _createTextVNode(" mdi-close ")
                    ])),
                    _: 2 /* DYNAMIC */,
                    __: [0]
                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]),
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("span", _hoisted_4, _toDisplayString(item.title), 1 /* TEXT */)
                ]),
                (item.message)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "message mb-2",
                        innerHTML: item.message
                    }, null, 8 /* PROPS */, _hoisted_5))
                    : _createCommentVNode("v-if", true),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "line" }, null, -1 /* CACHED */)),
                (item.storeName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => _cache[1] || (_cache[1] = [
                                _createTextVNode(" mdi-store ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [1]
                        }),
                        _createTextVNode(" 상점: " + _toDisplayString(item.storeName), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                (item.orderId)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => _cache[2] || (_cache[2] = [
                                _createTextVNode(" mdi-food ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [2]
                        }),
                        _createTextVNode(" 주문 아이디: " + _toDisplayString(item.orderId), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true),
                (item.workerName)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_v_icon, { size: "18" }, {
                            default: _withCtx(() => _cache[3] || (_cache[3] = [
                                _createTextVNode(" mdi-moped ")
                            ])),
                            _: 1 /* STABLE */,
                            __: [3]
                        }),
                        _createTextVNode(" 라이더: " + _toDisplayString(item.workerName), 1 /* TEXT */)
                    ]))
                    : _createCommentVNode("v-if", true)
            ], 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_2));
        }), 128 /* KEYED_FRAGMENT */))
    ]));
}
